export default __webpack_public_path__ + "static/media/laboratorio-italianoNC.b4a08f61.svg";